import {
  LOGISTICS_ORDER_TYPE_LABELS,
  type LogisticsOrderType,
} from '@/modules/logistics/types';

const TYPE_CLASS: Record<LogisticsOrderType, string> = {
  delivery: 'logistics-type--delivery',
  pickup: 'logistics-type--pickup',
  transfer: 'logistics-type--transfer',
};

type LogisticsTypeBadgeProps = {
  type: LogisticsOrderType;
};

export function LogisticsTypeBadge({ type }: LogisticsTypeBadgeProps) {
  return (
    <span className={`logistics-type ${TYPE_CLASS[type]}`}>
      {LOGISTICS_ORDER_TYPE_LABELS[type]}
    </span>
  );
}
